import { attributes } from "@type-r/models";

export type AssetTypeItemLookup = InstanceType<typeof AssetTypeItemLookup>;

export const AssetTypeItemLookup = attributes({
    id: Number,
    name: String
});